//这个只用于商业模拟系统的模型初始化
import * as THREE from "three";
import { Line2 } from "three/examples/jsm/lines/Line2.js";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry.js";
import hexRgb from 'hex-rgb'

// 用于将前端的数据结构进行一次封装
const assembleDataStructure = function(dataElement) {
  return {
    dataElementProperty: dataElement,
    dataId: dataElement.element_type,
    dataElementThreeObject: null
  };
};

const assembleBufferObj = function (dataElement, positions, colors){
  const allPointsOut = dataElement.dataElementProperty.element_exterior_geometry;
  const diffuse = dataElement.dataElementProperty.element_diffuse;
  const rgb = hexRgb(diffuse)
  const vercites = [
    allPointsOut[0][0], allPointsOut[0][1], 0,
    allPointsOut[1][0], allPointsOut[1][1], 0,
    allPointsOut[2][0], allPointsOut[2][1], 0,
    allPointsOut[2][0], allPointsOut[2][1], 0,
    allPointsOut[3][0], allPointsOut[3][1], 0,
    allPointsOut[4][0], allPointsOut[4][1], 0,
  ]

  const color = [
    rgb.red/255, rgb.green/255, rgb.blue/255,
    rgb.red/255, rgb.green/255, rgb.blue/255,
    rgb.red/255, rgb.green/255, rgb.blue/255,
    rgb.red/255, rgb.green/255, rgb.blue/255,
    rgb.red/255, rgb.green/255, rgb.blue/255,
    rgb.red/255, rgb.green/255, rgb.blue/255
  ]

  positions.push(...vercites)
  colors.push(...color)
}

// // 生成点物件用于展示出入口
// const createBox = function(dataElement) {
//   const diffuse = dataElement.dataElementProperty.element_diffuse;
//   const geometry = new THREE.BoxGeometry(1, 1, 1);
//   const material = new THREE.MeshLambertMaterial({color: diffuse});
//   const cube = new THREE.Mesh(geometry, material);
//   cube.position.x =
//     dataElement.dataElementProperty.element_exterior_geometry[0];
//   cube.position.z = -dataElement.dataElementProperty
//     .element_exterior_geometry[1];
//   cube.rotateX(-90 * (Math.PI / 180));
//   cube.position.y = dataElement.dataElementProperty.element_start_height;
//   return cube;
// };
// 生成线物件
const creatEntranceLineObject = function(dataElement) {
  const diffuse = dataElement.dataElementProperty.element_diffuse;
  const allPoints = dataElement.dataElementProperty.element_exterior_geometry;
  const point1 = new THREE.Vector3(allPoints[0][0], 0, -allPoints[0][1])
  const point2 = new THREE.Vector3(allPoints[allPoints.length - 1][0], 0, -allPoints[allPoints.length - 1][1])
  const length = point1.distanceTo(point2)
  var geometry = new THREE.BoxGeometry( 1, dataElement.dataElementProperty.element_height, length); // align length with z-axis
  geometry.translate( 0, 0, length / 2 ); // so one end is at the origin
  const material = new THREE.MeshLambertMaterial({color: diffuse});
  var cube = new THREE.Mesh( geometry, material );
  cube.position.copy( point1 );
  cube.lookAt( point2 );
  cube.position.y = dataElement.dataElementProperty.element_start_height + dataElement.dataElementProperty.element_height;
  return cube;
};

// 生成线物件
const creatLineObject = function(dataElement) {
  const diffuse = dataElement.dataElementProperty.element_diffuse;
  const material = new LineMaterial({ color: diffuse });
  material.opacity = dataElement.dataElementProperty.element_diffuse_opacity;
  material.transparent = true;
  const allPoints = dataElement.dataElementProperty.element_exterior_geometry;
  const points = [];
  for (var i = 0; i < allPoints.length - 1; i++) {
    points.push(allPoints[i][0], allPoints[i][1], 0);
  }
  const geometry = new LineGeometry().setPositions(points);
  material.linewidth = dataElement.dataElementProperty.element_outline_width;
  material.resolution.set(1000, 1000);

  const line = new Line2(geometry, material);
  line.computeLineDistances();
  line.rotateX(-90 * (Math.PI / 180));

  return line;
};

// 绘制用于挤出体块的polygon边线
const createBaseLine = function(shape, allPoints) {
  for (var i = 0; i < allPoints.length; i++) {
    if (i === 0) {
      shape.moveTo(allPoints[i][0], allPoints[i][1]);
    } else {
      shape.lineTo(allPoints[i][0], allPoints[i][1]);
    }
  }
  return shape;
};

// 对于polygon按照其高度挤出物件
const createPolygonObject = function(dataElement) {
  const diffuse = dataElement.dataElementProperty.element_diffuse;
  var extrudeSettings = {
    depth: dataElement.dataElementProperty.element_height,
    steps: 1,
    bevelEnabled: false
  };

  // 最外层的几何物件
  var shapeOut = new THREE.Shape();
  const allPointsOut =
    dataElement.dataElementProperty.element_exterior_geometry;
  shapeOut = createBaseLine(shapeOut, allPointsOut);

  // 检查是否是中空的polygon
  if (dataElement.dataElementProperty.element_is_hole === "true") {
    dataElement.dataElementProperty.element_interior_geometry.forEach(pts => {
      const curShape = createBaseLine(new THREE.Shape(), pts);
      // 扣掉中间的部分
      shapeOut.holes.push(curShape);
    });
  }
  // 物件颜色
  var geometryOut = new THREE.ExtrudeGeometry(shapeOut, extrudeSettings);
  const material = new THREE.MeshLambertMaterial({ color: diffuse });
  if (dataElement.dataElementProperty.element_type === "frame") {
    material.opacity = 0;
  } else {
    material.opacity = dataElement.dataElementProperty.element_diffuse_opacity;
  }
  material.transparent = true;
  var objectOut = new THREE.Mesh(geometryOut, material);


  objectOut.castShadow = false;
  objectOut.receiveShadow = false;
  objectOut.rotateX(-90 * (Math.PI / 180));
  objectOut.position.y = dataElement.dataElementProperty.element_start_height;
  // outlinePolygon.add(objectOut);
  return objectOut;
};

// 暂时通用化处理只支持LineSring物件以及Polygon物件
// 点物件可以用来做树或者别的锚点
const createModel = function(dataElement) {
  if (dataElement.dataElementProperty.element_geom_type === "Polygon") {
    dataElement.dataElementThreeObject = createPolygonObject(dataElement);
  } 
  else if (
    dataElement.dataElementProperty.element_geom_type === "LineString"
  ) {
    if (dataElement.dataElementProperty.element_type === "entrance"){
    dataElement.dataElementThreeObject = creatEntranceLineObject(dataElement)
    }
    else{
    dataElement.dataElementThreeObject = creatLineObject(dataElement)};
  } 
};

//  将给前端的datamodel以及场景放入这个函数即可直接将模型加载到场景中
export const dataModel2ThreeRaw = function(dataModel, scene) {
  const elementList = [];
  dataModel.model_elements.forEach(dataElement => {
    const curDataElement = assembleDataStructure(dataElement);
    createModel(curDataElement);
    scene.add(curDataElement.dataElementThreeObject);
    elementList.push(curDataElement);
  });
  return elementList;
};

//  将给前端的datamodel以及场景放入这个函数即可直接将模型加载到场景中
export const dataModel2Three = function(dataModel, scene, heatmapMesh, objectLabels) {
  const elementList = [];
  const positions = []
  const colors = []

  const geometry = new THREE.BufferGeometry()
  //处理非heatmap的部分
  dataModel.model_elements.forEach(dataElement => {
    const curDataElement = assembleDataStructure(dataElement);
    if(curDataElement.dataId === "heatmap"){
      assembleBufferObj(curDataElement, positions, colors)
    }else{
      createModel(curDataElement);
      if (
          // curDataElement.dataId==='stairs' ||
          curDataElement.dataId==="escalator"  ||
          curDataElement.dataId==="restroom" ||
          // curDataElement.dataId==="visitor_lift"  ||
          curDataElement.dataId==="shop" ||
          curDataElement.dataId==="shop_main" ||
          curDataElement.dataId==="spot_zone" ||
          curDataElement.dataId==="food" 
      ){
        if (dataElement.dataElementProperty.element_custom_semantics){
          const label = shopLabelMaker(curDataElement)
          objectLabels.push(label)
          scene.add(label)
        }
      }
      scene.add(curDataElement.dataElementThreeObject);
      elementList.push(curDataElement);
    }
  });

  geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3))
  geometry.setAttribute( 'color', new THREE.Float32BufferAttribute( colors, 3 ) )
  geometry.computeBoundingSphere()
  geometry.boundingBox = null
  const material = new THREE.MeshBasicMaterial( {
    // color: 0xf1f1f1, specular: 0xf1f1f1, shininess: 500,
    side: THREE.DoubleSide, vertexColors: true, transparent: true,
    opacity:0.8
  } );
  const mesh = new THREE.Mesh(geometry, material)
  mesh.rotateX(-90 * (Math.PI / 180));
  mesh.position.y = 0.4
  heatmapMesh.push(mesh)
  scene.add(mesh)
  return elementList;
};


//用于绘制分割线，以防看不清
const createDisplayOutline = function(dataElement) {
  const material = new LineMaterial({ color: 0xffffff });
  const allPoints = dataElement.element_exterior_geometry;
  const points = [];
  for (var i = 0; i < allPoints.length - 1; i++) {
    points.push(allPoints[i][0], allPoints[i][1], 0);
  }
  const geometry = new LineGeometry().setPositions(points);
  material.linewidth = 1;
  material.resolution.set(1000, 1000);

  const line = new Line2(geometry, material);
  line.computeLineDistances();
  line.rotateX(-90 * (Math.PI / 180));
  line.position.y = dataElement.element_start_height + dataElement.element_height + 0.1;
  return line;
};

export const displayObjectOutline = function(dataModel, scene) {
  const outlineLayer = [
    "walkable_zone",
    "visitor_lift",
    "stairs",
    "shop",
    "shop_excluded",
    "rest_room",
    "food",
    "escalator",
    "cargo_lift",
    "blocker",
    "cinema",
    "spot_zone"
  ];
  const outlines = [];
  dataModel.model_elements.forEach(dataElement => {
    if (outlineLayer.indexOf(dataElement.element_type) !== -1 && dataElement.element_geom_type ==='Polygon') {
      const curLine = createDisplayOutline(dataElement);
      scene.add(curLine);
      outlines.push(curLine)
    }
  });
  return outlines;
};

const shopLabelMaker = function (dataElement){
  // const allPointsOut = dataElement.dataElementProperty.element_exterior_geometry;
  const centerPt = dataElement.dataElementProperty.element_center
  let textContent
  // 获取商店类型
  if (dataElement.dataId === "stairs" ){
    textContent = "Stair"
  }else if (dataElement.dataId === "escalator" ){
    textContent = "Escalator"
  }else if (dataElement.dataId === "restroom" ){
    textContent = "Restroom"
  }else if (dataElement.dataId === "visitor_lift" ){
    textContent = "Handrail"
  }else if (dataElement.dataId === "shop" ){
    textContent = "Shop"
  }else if (dataElement.dataId === "food" ){
    textContent = "Food"
  }else if (dataElement.dataId === "spot_zone" ){
    textContent = "Art Space"
  }else if (dataElement.dataId === "shop_main" ){
      textContent = "Main Shop"
  } 
  if (dataElement.dataElementProperty.element_custom_semantics){
    textContent = textContent + " " + String(dataElement.dataElementProperty.element_custom_semantics.visitorValue)
    textContent = textContent + String(" " + dataElement.dataElementProperty.element_custom_semantics.viewerValue)
  }
  
  var ctx = document.createElement("canvas").getContext("2d");
  var width = 10 * textContent.length / 2 + 5;
  var height = 10;

  var r = window.devicePixelRatio;

  ctx.canvas.width = width * r;
  ctx.canvas.height = height * r;
  ctx.canvas.style.width = width + "px";
  ctx.canvas.style.height = height + "px";
  ctx.setTransform(r, 0, 0, r, 0, 0);

  ctx.textBaseline = "middle";
  ctx.textAlign = "center";
  ctx.fillStyle = `rgb(255, 255, 255)`;
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = "black";
  ctx.fillText(textContent, width / 2, height / 2);

  var texture = new THREE.CanvasTexture(ctx.canvas);
  texture.minFilter = THREE.LinearFilter;
  texture.wrapS = THREE.ClampToEdgeWrapping;
  texture.wrapT = THREE.ClampToEdgeWrapping;

  var material = new THREE.SpriteMaterial({ map: texture, depthTest: true });
  var sprite = new THREE.Sprite(material);
  sprite.position.set(
      centerPt[0],
      0,
      -centerPt[1],
  )
  sprite.scale.set(width/6 , height/6 , 1.0);
  sprite.position.y = 5
  sprite.renderOrder = 100
  return sprite
}

